import { safeFormatISODate } from '../../../util/datetime-fns';
import type { HotelOption, HotelRoom } from '../../types';

const baseUrl = 'https://www.finn.no/reise/hotell/wl/#/hotels';

export const createWhitelabelUrl = (
    destinationContext: HotelOption | undefined,
    startDate: Date | undefined,
    endDate: Date | undefined,
    rooms: HotelRoom[] | undefined,
) => {
    if (!rooms || !destinationContext) {
        // TODO how to handle this properly
        return '';
    }

    // Place id is not returned for hotels, but using 1 as place id works
    const key = destinationContext.type === 'hotel' ? `p1-h${destinationContext.key}` : `p${destinationContext.key}`;
    const place = destinationContext.hierarchy.join(',');
    const checkIn = safeFormatISODate(startDate);
    const checkOut = safeFormatISODate(endDate);

    const numAdults = rooms.reduce((acc, cur) => acc + cur.adults, 0);
    const numChildren = rooms.reduce((acc, cur) => acc + cur.children.length, 0);
    const childrenAges = rooms.flatMap((room) => room.children).join('-');
    const numRooms = rooms.length;

    const adultsText = `${numAdults}adults`;
    const childrenText = numChildren === 0 ? null : `${numAdults}children-${childrenAges}`;
    const roomsText = `${numRooms}rooms`;
    const countsText = [adultsText, childrenText, roomsText].filter((text) => !!text).join('/');

    return `${baseUrl}/${place}-${key}/${checkIn}/${checkOut}/${countsText}`;
};
